import { SITE } from '../constants/site';

// it mean pathname is /tw, /en ... and it is also discover page
export const isSiteIndexPage = pathname => {
  const isMatched = Object.values(SITE).findIndex(
    site => site.path === pathname,
  );

  if (isMatched === -1) {
    return false;
  }

  return true;
};

export const getCurrentSite = locale => {
  const siteInfo =
    Object.values(SITE).find(site => site.languages.includes(locale)) ||
    SITE.en;

  return siteInfo.site;
};
